import React, { useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import OrgCards from "../components/OrgCards";

const { GridView } = UiComponents;

function OrganizationSkeleton({ length = 5 }) {
  return (
    <>
      <GridView>
        {Array.from({ length: length }).map((_, index) => (
          <OrgCards
            orgImage="https://cdn.simulanis.io/sso/logos/default_simulanis.png"
            orgName="Simulanis Solutions"
            orgParent="Simulanis India"
            appCount="7"
            resourceCount="5"
            amount="200"
            manage={true}
          />
        ))}
      </GridView>
    </>
  );
}

export default OrganizationSkeleton;
